export default __webpack_public_path__ + "static/media/cisco.5ee72874.svg";